import { Inject, Injectable } from '@angular/core';
import { ENDPOINTS, OnlineOnlyService, UriUtilitiesService } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ODataSPQModel } from '../types/service-part-questionnaire';

@Injectable({
    providedIn: 'root',
})
export class OdataServicePartQuestionnaireService {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly onlineOnlyService: OnlineOnlyService,
        private readonly uriUtilities: UriUtilitiesService,
    ) {}

    public getQuestionnaireFromBackend(docId: string): Observable<ODataSPQModel> {
        this.log.info(
            `OdataServicePartQuestionnaireService: getQuestionnaireFromBackend: loading ${docId} xml from backend`,
        );
        let query = ENDPOINTS.GetSPQXMLSet.toString();
        const keys = `FormDocid eq '${encodeURIComponent(docId)}'`;
        query = this.uriUtilities.appendFilterValue(query, keys);

        return this.onlineOnlyService.get(query).pipe(map((questionnaireXML: ODataSPQModel[]) => questionnaireXML[0]));
    }
}
